// app/javascript/components/shared/ui/EmptyState.js
//
// Centred, muted text used for "no results" / "loading" placeholders inside
// tables, lists, and modal bodies. Layout-agnostic — the parent decides
// whether to box it in.
import React from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"

export const emptyStateVariants = cva(
  "text-center text-slate-400",
  {
    variants: {
      size: {
        sm: "py-6 text-xs",
        md: "py-8 text-sm",
        lg: "py-12 text-sm",
      },
    },
    defaultVariants: { size: "md" },
  }
)

const EmptyState = ({ size, className, ...props }) => (
  <div className={clsx(emptyStateVariants({ size }), className)} {...props} />
)

export default EmptyState
